import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import fetchBusinessEmployees from 'actions/businessTraveller/fetchBusinessEmployees'
import fetchMyApprovalQueue from 'actions/businessTraveller/fetchMyApprovalQueue'

interface Params {
  currentRegionCode: string,
  isEnabled?: boolean,
}

function useBusinessTravellerTripRequestApprovals(params: Params) {
  const { currentRegionCode, isEnabled = true } = params

  const appDispatch = useAppDispatch()
  const businessId = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.business?.id)
  const employeeId = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.employee?.id)
  const approvalRequests = useAppSelector(
    state => state.businessTraveller.approvalRequestsApprovals?.request || [],
  )
  const employees = useAppSelector(state => state.businessTraveller.employees.all)
  const status = useAppSelector(state => state.businessTraveller.approvalRequestsApprovals?.status)

  useEffect(() => {
    if (isEnabled && businessId) {
      appDispatch(fetchBusinessEmployees(businessId))
    }
  }, [appDispatch, businessId, isEnabled])

  useEffect(() => {
    if (isEnabled && businessId && currentRegionCode && employeeId && employees) {
      const employeesArray: Array<App.BusinessTraveller.EmployeeFromMeEndpoint> = Object.values(employees)
      appDispatch(fetchMyApprovalQueue(businessId, employeeId, currentRegionCode, employeesArray))
    }
  }, [appDispatch, businessId, employeeId, currentRegionCode, employees, isEnabled])

  return {
    pending: approvalRequests.filter(r => r.status === 'REQUESTED'),
    actioned: approvalRequests.filter(r => r.status !== 'REQUESTED'),
    status
  }
}

export default useBusinessTravellerTripRequestApprovals
